import React, { Component } from 'react';
import './style.css';
class PowerfulQueryHow extends Component {
  render() {
    return (
      <div>
        如何选科
      </div>
    );
  }
}

export default PowerfulQueryHow;


// WEBPACK FOOTER //
// ./src/containers/PowerfulQuery/components/PowerfulQueryHow/index.js